import { useEffect, useState } from 'react';
import styles from './Checkout.module.scss'
import { Button, Select, Space, Text } from '@mantine/core';
import Image from 'next/image'

import { consoleError, logEvent, setBrowserEmail } from '../lib/logger';

import creditCardsImage from '../images/creditcards.jpg'
import paypalImage from '../images/paypal.jpg'
import voucherImage from '../images/voucher.png'


import { useRawUmberContext } from '../lib/rawumberprovider';
import { okModal } from '../lib/utils';
import { CheckoutInformation, countryCodes, stateCodes } from '../lib/definitions';

type CheckoutProps =
{
    validationCallback: () =>boolean,
    resetCallback: () => void,
    free: boolean,
    allowVoucher?: boolean
}
export default function Checkout(props: CheckoutProps)
{
    const {shoppingCartItemRef} = useRawUmberContext();

    const { localizationInformation} = useRawUmberContext();

    async function paypalCheckout()
    {
        await checkout("getpaypalcheckoutsession");
    }

    async function checkout(url: string)
    {
        if (!props.validationCallback())
        {
            props?.resetCallback();
            return;
        }

        let cancelUrl = window.location.href;
        
        try
        {

        await setBrowserEmail(shoppingCartItemRef?.current?.emailAddress??'');

        let at =  await fetch('/n/api/' + url , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
              },
              credentials:"include",
              body: JSON.stringify({cartItem: shoppingCartItemRef?.current, cancelUrl: cancelUrl, currencyCode: localizationInformation?.CurrencyCode }),

          });   

          logEvent('checkout_started', { shoppingCart: shoppingCartItemRef?.current });

          let ret  : CheckoutInformation= await at.json();

          window.location.href = ret.url;


        }
        catch (e)
        {
            consoleError(e);
            props?.resetCallback();
            okModal("There was a problem checking out. Please try again later.");
        }


    }

    async function stripeCheckout()
    {
        await checkout("getstripecheckoutsession");
    }

    async function freeCheckout()
    {
        await checkout("getfreecheckoutsession");
    }

    async function voucherCheckout()
    {
        await checkout("getvouchercheckoutsession");
    }

    return(
        <>{!props.free && <Text align='center' weight={700}>To complete your purchase, choose one of these payment methods</Text>}

<Space h="md" />

{!props.free &&
<>
<div className={styles.paymentOptions}>
<div onClick={async() => await stripeCheckout()} className={styles.paymentBorder}><Image width={250} height={40} className={styles.payment} src={creditCardsImage} alt="Pay by credit card"/></div>
<div onClick={paypalCheckout} className={styles.paymentBorder}><Image width={164} height={40} className={styles.payment} src={paypalImage} alt="Pay by PayPal"/></div>
{props.allowVoucher && <div onClick={voucherCheckout} className={styles.paymentBorder}><Image width={261} height={40} className={styles.payment} src={voucherImage} alt="Pay by Voucher"/></div>}
</div>
</>}

{props.free &&
<>
<Button type='submit' onClick={async() => await freeCheckout()}>Submit</Button>
</>
}
</>

    );
}

export function CountryAndState(props: {defaultCountryCode: string, setCountryCode: (v: string | null)=> void, setStateCode: (v:string | null)=> void })
{
    const [countryCode, internalSetCountryCode] = useState<string|null>(props.defaultCountryCode);
    const [stateCode, internalSetStateCode] = useState<string|null> ("");

    useEffect(()=>
    {

        internalSetCountryCode(props.defaultCountryCode);
    },[props.defaultCountryCode]);

    function checkAndSetCountryCode(code : string | null)
    {
        let c=code?.endsWith("_")?code.substring(0, code.length-1):code;
        internalSetCountryCode(c);
        props.setCountryCode(c);
    }

    function setStateCode2(code : string | null)
    {
        internalSetStateCode(code);
        props.setStateCode(code);
    }


    let countryData : {value:string, label:string} [] = countryCodes.map<{value:string, label:string}>((x)=>{return ({value:x.Code, label:x.Name})});
    let statesData : {value:string, label:string} [] = stateCodes.map<{value:string, label:string}>((x)=>{return ({value:x.abbreviation, label:x.name})});

    let stateDiv = <></>

        if (countryCode == "US") {
            stateDiv =
            <>
                <Select
      data={statesData}
      label="State"
      placeholder="State"
      required
      searchable
      clearable
      value={stateCode}
      onChange={setStateCode2}
      error={!stateCode?"Please choose your state":false}
    />
            </>
        }


    return(<>
    <Select
      label="Country. We need this for tax purposes."
      data={countryData}
      value={countryCode}
      onChange={(v)=>checkAndSetCountryCode(v)}
      placeholder="Country"
      required
      searchable
      clearable
      error = {!countryCode?"Please choose your country": false}
    />

    {stateDiv}</>);

}